module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"editMeterTitle":"Datenpunkt bearbeiten","addMeterTitle":"Datenpunkt hinzufügen"}}')
  delete Component.options._Ctor
}
